import { useEffect, useState } from 'react'
import { consumirApi } from '../../../utils/consumoApi'
import { agregarDatosEmpresaUsuario } from '../../../utils/empresaUsuario'
import ErrorAlert from '../../../components/common/ErrorAlert'
import DatosJerarquicos from '../../../components/tables/DatosJerarquicos'
import Modal from '../../../components/modals/Modal'
import ModalConfirmacion from '../../../components/modals/ModalConfirmacion'
import Form from '../../../components/forms/Form'
import Input from '../../../components/common/Input'
import Notification from '../../../components/common/Notification'
import Spinner from '../../../components/common/Spinner'
import Button from '../../../components/common/Button'

const Plazos = () => {
    const [datos, setDatos] = useState([])
    const idEmpresa = JSON.parse(localStorage.getItem('empresa'))
    // campos 
    const [idPlazo, setIdPlazo] = useState("")
    const [idPlazoDetalle, setIdPlazoDetalle] = useState("")
    const [plazo, setPlazo] = useState("")
    const [plazoDetalle, setPlazoDetalle] = useState("")
    // modales
    const [mostrarModalRegistrarPlazo, setMostrarModalRegistrarPlazo] = useState(false)
    const [mostrarModalRegistrarPlazoDetalle, setMostrarModalRegistrarPlazoDetalle] = useState(false)
    const [mostrarModalEditarPlazo, setMostrarModalEditarPlazo] = useState(false)
    const [mostrarModalEditarPlazoDetalle, setMostrarModalEditarPlazoDetalle] = useState(false)
    const [mostrarModalConfirmacion, setMostrarModalConfirmacion] = useState(false)
    const [mostrarModalConfirmacionDetalle, setMostrarModalConfirmacionDetalle] = useState(false)
    // notificaciones y cargas 
    const [cargando, setCargando] = useState(true)
    const [error, setError] = useState("")
    const [notificacion, setNotificacion] = useState({ estado: false, tipo: "", mensaje: "" })
    const [isSubmitting, setIsSubmitting] = useState(false)


    // Carga inicial de los plazos con sus detalles
    useEffect(() => { obtenerPlazos() }, [])

    // Función para traer los plazos con sus detalles
    const obtenerPlazos = async () => {
        const respuesta = await consumirApi('GET', `maestros/plazo/${idEmpresa}`)
        setDatos(respuesta.success ? respuesta.data : respuesta.error)
        setCargando(false)
    }

    // Registro de un nuevo plazo
    const registrarPlazo = async (e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        agregarDatosEmpresaUsuario(formData)
        setIsSubmitting(true)
        const respuesta = await consumirApi('POST', 'maestros/plazo', formData)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "registro", mensaje: "Plazo registrado correctamente" })
            limpiarCampos()
            obtenerPlazos()
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    // Abrir modal para editar una cuota
    const abrirModalEditarPlazo = (data) => {
        setIdPlazo(data.id)
        setPlazo(data.descripcion)
        setMostrarModalEditarPlazo(true)
    }

    // Enviar los cambios de una cuota editada
    const enviarEdicionPlazo = async (e) => {
        e.preventDefault()
        const data = { tramite: plazo, }
        setIsSubmitting(true)
        const respuesta = await consumirApi('PATCH', `maestros/plazo/${idPlazo}`, data)

        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "actualizacion", mensaje: "Nombre de plazo actualizado correctamente" })
            limpiarCampos()
            obtenerPlazos()
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    // Apertura del modal para registrar un nuevo PlazoDetalle
    const abrirModalRegistroPlazoDetalle = (plazo) => {
        setIdPlazo(plazo)
        setMostrarModalRegistrarPlazoDetalle(true)
    }

    // Registro de un nuevo PlazoDetalle
    const registrarPlazoDetalle = async (e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        setIsSubmitting(true)
        const respuesta = await consumirApi('POST', `maestros/plazo-detalle`, formData)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "registro", mensaje: "Plazo detalle registrado correctamente" })
            limpiarCampos()
            obtenerPlazos()
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    // Apertura del modal para editar un PlazoDetalle
    const abrirModalEditar = (data) => {
        setIdPlazoDetalle(data.id)
        setPlazoDetalle(data.nombre)
        setMostrarModalEditarPlazoDetalle(true)
    }

    // Edición de un PlazoDetalle
    const enviarEdicionPlazoDetalle = async (e) => {
        e.preventDefault()
        const data = { descripcion: plazoDetalle }
        setIsSubmitting(true)
        const respuesta = await consumirApi('PATCH', `maestros/plazo-detalle/${idPlazoDetalle}`, data)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "actualizacion", mensaje: "Plazo detalle actualizado correctamente" })
            limpiarCampos()
            obtenerPlazos()
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    // Apertura del modal de confirmación para eliminar un tipo de proyecto
    const abrirModalEliminar = (id) => {
        setIdPlazo(id)
        setMostrarModalConfirmacion(true)
    }

    // Eliminación de un tipo de proyecto
    const eliminarPlazo = async () => {
        const respuesta = await consumirApi('DELETE', `maestros/plazo/${idPlazo}`)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "eliminar", mensaje: "Plazo eliminado correctamente" })
            setMostrarModalConfirmacion(false)
            obtenerPlazos()
        } else {
            setError(respuesta.error)
        }
    }

    // Apertura del modal de confirmación para eliminar un PlazoDetalle
    const abrirModalEliminarDetalle = (id) => {
        setIdPlazoDetalle(id)
        setMostrarModalConfirmacionDetalle(true)
    }

    // Eliminación de un PlazoDetalle
    const eliminarPlazoDetalle = async () => {
        const respuesta = await consumirApi('DELETE', `maestros/plazo-detalle/${idPlazoDetalle}`)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "eliminar", mensaje: "Plazo detalle eliminado correctamente" })
            setMostrarModalConfirmacionDetalle(false)
            obtenerPlazos()
        } else {
            setError(respuesta.error)
        }
    }

    // Limpieza de campos y cierre de modales
    const limpiarCampos = () => {
        setMostrarModalRegistrarPlazo(false)
        setMostrarModalRegistrarPlazoDetalle(false)
        setMostrarModalEditarPlazo(false)
        setMostrarModalEditarPlazoDetalle(false)
        setMostrarModalConfirmacion(false)
        setMostrarModalConfirmacionDetalle(false)
        setPlazo('')
        setIdPlazo('')
        setPlazoDetalle('')
        setError('')
        setTimeout(() => {
            setIsSubmitting(false)
        }, 300)
    }

    return (
        <div className='w-full min-h-[calc(100vh-50px)]'>
            <Button className="ml-5 mt-2" texto='+ Nuevo' onClick={() => setMostrarModalRegistrarPlazo(true)} />
            {notificacion.estado && (
                <Notification estadoNotificacion={setNotificacion} type={notificacion.tipo} mensaje={notificacion.mensaje} />
            )}
            {cargando ? (
                <Spinner />
            ) : (
                datos.length === 0 ? (
                    <div className="ml-5">No se encontraron tipos de proyectos</div>
                ) : (
                    <div className="max-h-content overflow-y-auto">
                        <DatosJerarquicos
                            data={datos}
                            eliminar={abrirModalEliminar}
                            eliminarDetalle={abrirModalEliminarDetalle}
                            editar={abrirModalEditar}
                            editarPadre={abrirModalEditarPlazo}
                            registrar={abrirModalRegistroPlazoDetalle}
                            campoTitulo="tramite"
                            campoDetalles="plazos_detalle"
                            campoNombre="descripcion"
                        />
                    </div>
                )
            )}

            {/* Modales */}
            <Modal isOpen={mostrarModalRegistrarPlazo} title="Registrar nuevo Plazo" onClose={limpiarCampos}>
                <Form onSubmit={registrarPlazo} isSubmitting={isSubmitting}>
                    <Input name="tramite" value={plazo} label="Tipo de tramite" onChange={setPlazo} />
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>

            {/* Modal para registrar un nuevo PlazoDetalle */}
            <Modal isOpen={mostrarModalRegistrarPlazoDetalle} title="Registrar nuevo Plazo detalle" onClose={limpiarCampos}>
                <Form onSubmit={registrarPlazoDetalle} isSubmitting={isSubmitting}>
                    <Input name="plazo_id" value={idPlazo} show='hidden' />
                    <Input name="descripcion" value={plazoDetalle} label="descripcion" onChange={setPlazoDetalle} />
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>

            {/* Modales para editar plazo*/}
            <Modal isOpen={mostrarModalEditarPlazo} title="Actualizar nombre de plazo" onClose={limpiarCampos} >
                <Form onSubmit={enviarEdicionPlazo} isSubmitting={isSubmitting} >
                    <Input name="tramite" value={plazo} label="Plazo" onChange={setPlazo} />
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>

            {/* Modal para editar un PlazoDetalle */}
            <Modal isOpen={mostrarModalEditarPlazoDetalle} title="Editar plazo detalle" onClose={limpiarCampos}>
                <Form onSubmit={enviarEdicionPlazoDetalle} isSubmitting={isSubmitting} type="update" >
                    <Input name="descripcion" value={plazoDetalle} label="Descripcion" onChange={setPlazoDetalle} />
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>

            {/* Modal de confirmación para eliminar un tipo de proyecto*/}
            <ModalConfirmacion
                isOpen={mostrarModalConfirmacion}
                onClose={limpiarCampos}
                onConfirm={eliminarPlazo}
                mensaje="¿Estás seguro de que deseas eliminar Plazo?"
            >
                {error && <ErrorAlert message={error} />}
            </ModalConfirmacion>

            {/* Modal de confirmación para eliminar un PlazoDetalle */}
            <ModalConfirmacion
                isOpen={mostrarModalConfirmacionDetalle}
                onClose={limpiarCampos}
                onConfirm={eliminarPlazoDetalle}
                mensaje="¿Estás seguro de que deseas eliminar este Plazo Detalle?"
            >
                {error && <ErrorAlert message={error} />}
            </ModalConfirmacion>
        </div>
    )
}

export default Plazos